import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/MallApi/goodscate'

export default {

    getCateList(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getCateList',
            method: 'get',
            params,
        })
    },
    getCateTree(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getCateTree',
            method: 'get',
            params,
        })
    },
    getTree(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getTree',
            method: 'get',
            params,
        })
    },

    //添加
    add(data) {
        return request({
            url: BASE_URL + '/add',
            method: 'post',
            data
        })
    },

    //编辑
    update(data) {
        return request({
            url: BASE_URL + '/edit',
            method: 'post',
            data
        })
    },

    //删除
    delete(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/delete',
            method: 'get',
            params
        })
    },
}